var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-popover-counter"},[_c('p',[_vm._v("Vuex counter value: "+_vm._s(_vm.valueToShow))]),_vm._v(" "),_c('p',[_c('global-counter-iterator')],1),_vm._v(" "),_c('p',[_c('global-counter-iterator',{attrs:{"reverse":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-129125a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popovers/PopoverCounter.vue
// module id = 362
// module chunks = 0